window.addEventListener('DOMContentLoaded', () => {
    const header = document.querySelector('.component-header');
    const STICKY_SCROLL_OFFSET = 100; // The point at which the header becomes sticky

    function getHeaderHeight() {
        return header ? header.clientHeight : 0;
    }

    function smoothScrollTo(targetId) {
        const targetSection = document.getElementById(targetId);
        if (targetSection) {
            const initialHeaderHeight = getHeaderHeight();
            const offsetTop = targetSection.getBoundingClientRect().top + window.scrollY - initialHeaderHeight;
            window.scrollTo({ behavior: 'smooth', top: offsetTop });

            // Continuously adjust the scroll position until the target section is in view
            const interval = setInterval(() => {
                const currentHeaderHeight = getHeaderHeight();
                const newOffsetTop = targetSection.getBoundingClientRect().top + window.scrollY - currentHeaderHeight;
                if (Math.abs(window.scrollY - newOffsetTop) > 1) {
                    window.scrollTo({ behavior: 'smooth', top: newOffsetTop });
                } else {
                    clearInterval(interval);
                }
            }, 100);
        }
    }

    function handlePageLoadWithHash() {
        const initialHash = window.location.hash;
        if (initialHash) {
            window.history.replaceState(null, null, ' ');
            window.scrollTo(0, 0);
            setTimeout(() => {
                const targetId = initialHash.substring(1);
                window.history.replaceState(null, null, initialHash);
                smoothScrollTo(targetId);
            }, 500);
        }
    }

    function handleLinkClick(event, href, targetId) {
        event.preventDefault();
        if (href.startsWith('#')) {
            window.history.pushState(null, null, href);
            smoothScrollTo(targetId);
        } else if (href.startsWith(window.location.origin)) {
            if (href.split('#')[0] === window.location.origin + window.location.pathname) {
                window.history.pushState(null, null, href);
                smoothScrollTo(targetId);
            } else {
                sessionStorage.setItem('targetHash', targetId);
                window.location.href = href;
            }
        }
    }

    function initializeLinks() {
        const links = document.querySelectorAll('a[href*="#"]');
        links.forEach(link => {
            link.addEventListener('click', function (event) {
                const href = this.getAttribute('href');
                const targetId = href.split('#')[1];
                handleLinkClick(event, href, targetId);
            });
        });
    }

    function handleStoredHash() {
        const storedHash = sessionStorage.getItem('targetHash');
        if (storedHash) {
            sessionStorage.removeItem('targetHash');
            window.scrollTo(0, 0);
            setTimeout(() => {
                smoothScrollTo(storedHash);
            }, 500);
        }
    }

    function initialize() {
        handlePageLoadWithHash();
        initializeLinks();
        handleStoredHash();
        window.addEventListener('hashchange', () => {
            const targetId = window.location.hash.substring(1);
            smoothScrollTo(targetId);
        });
    }

    initialize();
});
